export const LOYALTY_BEZIER = 'cubic-bezier(0.49, 0.03, 0.13, 0.99)';
